/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_ErrorInputs */

const en_us2_progress_error = /** @type {(inputs: Progress_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load your progress.`)
};

const pt_br2_progress_error = /** @type {(inputs: Progress_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar seu progresso.`)
};

const es_419_progress_error = /** @type {(inputs: Progress_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar tu progreso.`)
};

const pt_pt2_progress_error = /** @type {(inputs: Progress_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar o teu progresso.`)
};

const fr_fr2_progress_error = /** @type {(inputs: Progress_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger ta progression.`)
};

const de_de2_progress_error = /** @type {(inputs: Progress_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Fortschritt konnte nicht geladen werden.`)
};

const it_it2_progress_error = /** @type {(inputs: Progress_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare i tuoi progressi.`)
};

/**
* | output |
* | --- |
* | "Couldn't load your progress." |
*
* @param {Progress_ErrorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_error = /** @type {((inputs?: Progress_ErrorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_ErrorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_error(inputs)
	if (locale === "es-419") return es_419_progress_error(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_error(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_error(inputs)
	if (locale === "de-DE") return de_de2_progress_error(inputs)
	if (locale === "it-IT") return it_it2_progress_error(inputs)
	return en_us2_progress_error(inputs)
});
export { progress_error as "progress.error" }